import './App.css';
import { Routes, Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
const Home = lazy(() => import('./pages/Home.js'));
const FinalOperativeReport = lazy(() => import('./pages/ReportsManagement/FinalOperativeReport.jsx'));
const Login = lazy(() => import('./pages/Login/LoginPage.jsx'));
const Unauthorized = lazy(() => import('./pages/Unauthorized/Unauthorized.jsx'));
const ProtectedRoute = lazy(() => import('./pages/components/ProtectedRoute.js'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword/ForgotPassword.jsx'));
const ResetPassword = lazy(() => import('./pages/ResetPassword/ResetPassword.jsx'));
const RemoteSignature = lazy(() => import('./pages/components/RemoteSignature.js'));
const UserPage = lazy(() => import('./pages/UserManagement/UserPage.jsx'));
const UserListPage = lazy(() => import('./pages/UserManagement/UserListPage.jsx'));
const UserAuditLog = lazy(() => import('./pages/UserManagement/UserAuditLog.jsx'));
const RolePage = lazy(() => import('./pages/RoleManagement/RolePage.jsx'));
const RoleListPage = lazy(() => import('./pages/RoleManagement/RoleListPage.jsx'));
const PermissionManagement = lazy(() => import('./pages/RoleManagement/PermissionManagement.jsx'));
const PatientPage = lazy(() => import('./pages/PatientManagement/PatientPage.jsx'));
const PatientListPage = lazy(() => import('./pages/PatientManagement/PatientListPage.jsx'));
const MainPage = lazy(() => import('./pages/MainPage.js'));
const InventoryPage = lazy(() => import('./pages/InventoryManagement/InventoryPage.jsx'));
const InventoryListPage = lazy(() => import('./pages/InventoryManagement/InventoryListPage.jsx'));
const OTDashboard = lazy(() => import('./pages/OTManagement/OTDashboard/OTDashboard.jsx'));
const OTCalendar = lazy(() => import('./pages/OTManagement/OTCalendar/OTCalendar.jsx'));
const OTBooking = lazy(() => import('./pages/OTManagement/OTBookingList/OTBookingList.jsx'));
const OTBookingPage = lazy(() => import('./pages/OTManagement/OTBookingPage.jsx'));
const OTRooms = lazy(() => import('./pages/OTManagement/OTRooms/OTRooms.jsx'));
const OTRoomMaster = lazy(() => import('./pages/OTManagement/OTRoomMaster/OTRoomMaster.jsx'));
const DoctorMaster = lazy(() => import('./pages/OTManagement/DoctorMaster/DoctorMaster.jsx'));
const SurgeryTypeMaster = lazy(() => import('./pages/OTManagement/SurgeryTypeMaster/SurgeryTypeMaster.jsx'));
const OTReports = lazy(() => import('./pages/OTManagement/OTReports/OTReports.jsx'));
const AuditCenter = lazy(() => import('./pages/Administration/AuditCenter/AuditCenter.jsx'));
const FeedbackPage = lazy(() => import('./pages/FeedbackManagement/FeedbackPage.jsx'));
const FeedbackListPage = lazy(() => import('./pages/FeedbackManagement/FeedbackListPage.jsx'));
const VideoRecorder = lazy(() => import('./pages/components/videorecorder.js'));
const VoiceRecorder = lazy(() => import('./pages/components/voicerecorder.js'));
const AddFile = lazy(() => import('./pages/AddFile/AddFilePage.jsx'));
const ConsentForAnaestnesia = lazy(() => import('./pages/PreOperative/consentForAnaesthesia/ConsentForAnaesthesia'));
const ConsentForMedical = lazy(() => import('./pages/PreOperative/consentForm/ConsentForm'));
const SurgicalSafetyChecklist = lazy(() => import('./pages/PreOperative/surgicalSafetyChecklist/SurgicalSafetyChecklist'));
const HighRiskConsentForm = lazy(() => import('./pages/PreOperative/highRiskConsent/HighRiskConsentForm'));
const PreOperativeChecklist = lazy(() => import('./pages/PreOperative/preOpChecklist/PreOperativeChecklist'));
const ConfirmationPhase = lazy(() => import('./pages/PreOperative/confirmationPhase/ConfirmationPhase'));
const PreoperativeOrders = lazy(() => import('./pages/PreOperative/preOpOrders/PreOperativeOrders'));
const PreAnaestheticForm = lazy(() => import('./pages/PreOperative/preAnaestheticForm/PreAnaestheticForm'));
const IntraOperativeNursingRecord = lazy(() => import('./pages/IntraOperative/intraOperativeNursingRecord/IntraOperativeNursingRecord.js'));
const OperationSheet = lazy(() => import('./pages/IntraOperative/operationSheet/OperationSheet.js'));
const IntraPostOperativeOrders = lazy(() => import('./pages/PostOperative/postOpOrders/PostOperativeOrders'));
const PostOperative = lazy(() => import('./pages/PostOperative/postOperativeHub/PostOperativeHub'));
const AldreteScore = lazy(() => import('./pages/PostOperative/aldreteScore/AldreteScore'));
const PostOperativeHandover = lazy(() => import('./pages/PostOperative/postOpHandover/PostOperativeHandover'));
const PostOperativeInstructions = lazy(() => import('./pages/PostOperative/postOpInstructions/PostOperativeInstructions'));
const PostOperativeTable = lazy(() => import('./pages/PostOperative/analgesiaAssessment/AnalgesiaAssessmentChart'));
const ConsiderationPhase = lazy(() => import('./pages/ConsiderationPhase/considerationPhase/ConsiderationPhase.js'));
const AnesthesiaForm = lazy(() => import('./pages/PreOperative/anesthesiaForm/AnesthesiaForm'));



// Public component

// User Management
// Role Management

// Patient Management
// Inventory Management
// OT Management
// Feedback Management

// Pre-operative



// Intra-operative


// Post-operative


// Other


function App() {
  return (
    <Suspense fallback={<div className="flex h-screen w-full items-center justify-center"><div className="text-slate-500 font-semibold">Loading Application Module...</div></div>}>
    <Routes>
      {/* Public Routes */}
      <Route path='/' element={<Login />} />
      <Route path='/login' element={<Login />} />
      <Route path='/unauthorized' element={<Unauthorized />} />

      <Route path="/forgot_password" element={<ForgotPassword />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />


      {/* Admin-only Routes */}
      <Route
        path='/addUser'
        element={
          <ProtectedRoute allowedPermissions={['Users Add']}>
            <UserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editUser/:user_id'
        element={
          <ProtectedRoute allowedPermissions={['Users Edit']}>
            <UserPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/user'
        element={
          <ProtectedRoute allowedPermissions={['Users View']}>
            <UserListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/userAuditLog'
        element={
          <ProtectedRoute allowedPermissions={['Users View']}>
            <UserAuditLog />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addRole'
        element={
          <ProtectedRoute allowedPermissions={['Roles Add']}>
            <RolePage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editRole/:role_id'
        element={
          <ProtectedRoute allowedPermissions={['Roles Edit']}>
            <RolePage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/roleList'
        element={
          <ProtectedRoute allowedPermissions={['Roles View']}>
            <RoleListPage />
          </ProtectedRoute>
        }
      />

      {/* Shared Protected Routes (Admin + Nurse) */}
      <Route
        path='/home'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <Home />
          </ProtectedRoute>
        }
      />
            <Route
        path='/voice'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <VoiceRecorder />
          </ProtectedRoute>
        }
      />
      <Route
        path='/video'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <VideoRecorder />
          </ProtectedRoute>
        }
      />
      <Route
        path='/signature-form/:uhid/:token'
        element={
          <ProtectedRoute allowedPermissions={['Consents Edit']}>
            <RemoteSignature />
          </ProtectedRoute>
        }
      />

      <Route
        path='/addPatient'
        element={
          <ProtectedRoute allowedPermissions={['Patients Add']}>
            <PatientPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editPatient/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Patients Edit']}>
            <PatientPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listPatient'
        element={
          <ProtectedRoute allowedPermissions={['Patients View']}>
            <PatientListPage />
          </ProtectedRoute>
        }
      />

      <Route
        path='/preoperativeorders/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Op Orders View']}>
            <PreoperativeOrders />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preInductionAssessment/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Anaesthetic Evaluation View']}>
            <AnesthesiaForm />
          </ProtectedRoute>
        }
      />
      <Route
        path='/mainPage/:uhid_no'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <MainPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addInventory'
        element={
          <ProtectedRoute allowedPermissions={['Inventory Add']}>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editInventory/:item_id'
        element={
          <ProtectedRoute allowedPermissions={['Inventory Edit']}>
            <InventoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listInventory'
        element={
          <ProtectedRoute allowedPermissions={['Inventory View']}>
            <InventoryListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otRooms'
        element={
          <ProtectedRoute allowedPermissions={['OT Rooms View']}>
            <OTRooms />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otRoomMaster'
        element={
          <ProtectedRoute allowedPermissions={['OT Rooms View']}>
            <OTRoomMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path='/doctorMaster'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <DoctorMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path='/surgeryTypeMaster'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <SurgeryTypeMaster />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otReports'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <OTReports />
          </ProtectedRoute>
        }
      />
      <Route
        path='/auditCenter'
        element={
          <ProtectedRoute allowedPermissions={['Users View']}>
            <AuditCenter />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otDashboard'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <OTDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otCalendar'
        element={
          <ProtectedRoute allowedPermissions={['Dashboard View']}>
            <OTCalendar />
          </ProtectedRoute>
        }
      />
      <Route
        path='/otBooking'
        element={
          <ProtectedRoute allowedPermissions={['OT Booking View']}>
            <OTBooking />
          </ProtectedRoute>
        }
      />

      <Route
        path='/addOtBooking'
        element={
          <ProtectedRoute allowedPermissions={['OT Booking Add']}>
            <OTBookingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/editOtBooking/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['OT Booking Edit']}>
            <OTBookingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addFeedback'
        element={
          <ProtectedRoute allowedPermissions={['Patient Feedback Add']}>
            <FeedbackPage />
          </ProtectedRoute>
        }
      />
      <Route
        path='/listFeedback'
        element={
          <ProtectedRoute allowedPermissions={['Patient Feedback View']}>
            <FeedbackListPage />
          </ProtectedRoute>
        }
      />

      {/* Pre-Operative Routes */}

      <Route
        path='/consentForAnaesthesia/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <ConsentForAnaestnesia />
          </ProtectedRoute>
        }
      />
      <Route
        path='/consentForMedical/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <ConsentForMedical />
          </ProtectedRoute>
        }
      />
      <Route
        path='/surgicalSafetyChecklist/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Surgical Safety Checklist View']}>
            <SurgicalSafetyChecklist />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preAnaestheticForm/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Anaesthetic Evaluation View']}>
            <PreAnaestheticForm />
          </ProtectedRoute>
        }
      />
      {/* <Route
      //   path='/preAnaestheticForm/:uhid_no'
      //   element={
      //     <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
      //       <PreAnaestheticForm />
      //     </ProtectedRoute>
      //   }
      // />
      <Route
        path='/2'
        element={
          <ProtectedRoute allowedRoles={['Admin', 'Nurse', 'OT Manager', 'Doctor', 'Staff']}>
            <PreAnaestheticForm2 />
          </ProtectedRoute>
        }
      /> */}
      <Route
        path='/highRiskConsentForm/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <HighRiskConsentForm />
          </ProtectedRoute>
        }
      />
      <Route
        path='/preOperativeChecklist/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Op Checklist View']}>
            <PreOperativeChecklist />
          </ProtectedRoute>
        }
      />
      <Route
        path='/confirmationPhase/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Pre-Op Checklist View']}>
            <ConfirmationPhase />
          </ProtectedRoute>
        }
      />

      {/* Intra-Operative Routes */}

      <Route
        path='/intraOperativeNursingRecord/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Nursing Record View']}>
            <IntraOperativeNursingRecord />
          </ProtectedRoute>
        }
      />
      <Route
        path='/operationSheet/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Operation Sheet View']}>
            <OperationSheet />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeOrders/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Orders View']}>
            <IntraPostOperativeOrders />
          </ProtectedRoute>
        }
      />

      {/* Post-Operative Routes */}
      <Route
        path='/postOperative/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Orders View']}>
            <PostOperative />
          </ProtectedRoute>
        }
      />
      <Route
        path='/aldreteScore/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Alderete Score View']}>
            <AldreteScore />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeHandover/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Handover View']}>
            <PostOperativeHandover />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeInstructions/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Instructions View']}>
            <PostOperativeInstructions />
          </ProtectedRoute>
        }
      />
      <Route
        path='/postOperativeAssesment/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Post-Op Instructions View']}>
            <PostOperativeTable />
          </ProtectedRoute>
        }
      />
      <Route
        path='/addfile/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Patients Edit']}>
            <AddFile />
          </ProtectedRoute>
        }
      />


      <Route
        path='/considerationPhase/:uhid_no'
        element={
          <ProtectedRoute allowedPermissions={['Consents View']}>
            <ConsiderationPhase />
          </ProtectedRoute>
        }
      />
      <Route
        path='/roleManagement'
        element={
          <ProtectedRoute allowedPermissions={['Roles View']}>
            <PermissionManagement />
          </ProtectedRoute>
        }
      />
      {/* Catch-all route redirects to login */}
      <Route path="*" element={<Login />} />
          <Route path='/finalOperativeReport/:uhid_no' element={<FinalOperativeReport />} />
    </Routes>
    </Suspense>
  );
}

export default App;
